// extracted by mini-css-extract-plugin
export default {"root":"DiffContainer_root__7Sx1Y","button":"DiffContainer_button__yPPsj","statusText":"DiffContainer_statusText__iJKGW","noChange":"DiffContainer_noChange__4RmK5"};